"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const uniq_1 = __importDefault(require("lodash/uniq"));
const filter_1 = __importDefault(require("lodash/filter"));
const includes_1 = __importDefault(require("lodash/includes"));
/**
 * @param {string[] | null | undefined} patientLanguagePreference
 * @param {string[] | null | undefined} projectLanguagePreference
 * @returns {string[]}
 */
const mergeLanguagePreference = (patientLanguagePreference, projectLanguagePreference) => {
    return (0, uniq_1.default)([
        ...(0, filter_1.default)(patientLanguagePreference, (language) => (0, includes_1.default)(projectLanguagePreference, language)),
        ...(projectLanguagePreference || []),
    ]);
};
exports.default = mergeLanguagePreference;
//# sourceMappingURL=mergeLanguagePreference.js.map